import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import moment from 'moment';
import { Dropdown } from 'primereact/dropdown';
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {Calendar} from "primereact/calendar";
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';

const PricelistitemFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [currency, setCurrency] = useState([]);
  const [unit, setUnit] = useState([]);
  const [technology, setTechnology] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().priceListItemId) || (entity === 'price-list-item' && id)) {
      apiCall('patch', '/api/v2/price-list-item/' + (window.App.urlVars().priceListItemId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderPricelistitemList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/price-list-item', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderPricelistitemList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/settings/price-list-item/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/currency')
      .then(response => {
        setCurrency(response.data.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    apiCall('get', '/api/v2/unit')
      .then(response => {
        setUnit(response.data.data?.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    apiCall('get', '/api/v2/technology')
      .then(response => {
        setTechnology(response.data.data?.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    if ((!window.App.urlVars().create && window.App.urlVars().priceListItemId) || (entity === 'price-list-item' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/price-list-item/' + (window.App.urlVars().priceListItemId ?? id))
        .then(response => {
          setFormData({
            ...response.data.data,
            technology: response.data?.data?.technology?.id || null,
            unit: response.data?.data?.unit?.id || null,
          })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"pricelistitem-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="technology" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="technology"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('technology')}</label>
                  <span className="p-d-block">
                      <Dropdown id="technology" {...input}
                                 onChange={(e) => {
                                  const selectedId = e.value;
                                  const selectedTech = (technology || []).find(x => x.id === selectedId);
                                  const currentName = (formData?.name || '').trim();
                                  const shouldAutofillName = !currentName;
                                  const autoName = currentName ? formData.name : (selectedTech?.name || '');
                                   setFormData({
                                     ...formData,
                                     technology: e.value,
                                     ...(shouldAutofillName ? { name: autoName } : {})
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     technology: e.value,
                                     ...(shouldAutofillName ? { name: autoName } : {})
                                   })
                                 }}
                                 value={formData.technology}
                                  options={window.App.sortDropdownOptions(technology, "name")}
                                 optionLabel='name'
                                 optionValue='id'
                                 emptyMessage={t('noTechnologyYet')}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="price" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="price"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPrice')}</label>
                  <span className="p-d-block">
                      <InputNumber id="price" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     price: e.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     price: e.value
                                   })
                                 }}
                                 value={formData.price}
                                 mode="decimal"
                                 maxFractionDigits={2}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="currency" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="currency"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                  <span className="p-d-block">
                      <Dropdown id="currency" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     currency: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     currency: e.target.value
                                   })
                                 }}
                                 value={formData.currency}
                                 options={window.App.sortDropdownOptions(currency, "key")}
                                 optionLabel='key'
                                 optionValue='key'
                                 emptyMessage={t('noCurrencyYet')}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="unit" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="unit"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldUnitOfMeasureShort')}</label>
                  <span className="p-d-block">
                      <Dropdown id="unit" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     unit: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     unit: e.target.value
                                   })
                                 }}
                                  options={window.App.sortDropdownOptions(unit, "name")}
                                  optionLabel='name'
                                  optionValue='id'
                                 emptyMessage={t('noUnitShortYet')}
                                 value={formData.unit}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>
            
            <div className={"p-col-12 p-lg-6"}>
              <Field name="valid_from" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="valid_from"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldValidityStart')}</label>
                  <span className="p-d-block">
                    <div className="p-inputgroup calendar-icon-only">
                      <InputMask id="valid_from" {...input}
                                 mask={'9999-99-99'}
                                 placeholder={t('datePlaceholder')}onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     valid_from: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     valid_from: e.target.value
                                   })
                                 }}
                                 value={formData.valid_from}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                              />
                        <Calendar value={formData.valid_from}
                          locale="hu"
                          format={'yy-mm-dd'}
                          showIcon
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              valid_from: moment.utc(e.value).local().format('YYYY-MM-DD')
                            })
                            setNewFormData({
                              ...newFormData,
                              valid_from: moment.utc(e.value).local().format('YYYY-MM-DD')
                            })
                          }}/>
                        </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="valid_until" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="valid_until"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldValidityEnd')}</label>
                  <span className="p-d-block">
                     <div className="p-inputgroup calendar-icon-only">
                      <InputMask id="valid_until" {...input}
                                 mask={'9999-99-99'}
                                 placeholder={t('datePlaceholder')}onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     valid_until: moment.utc(e.target.value, 'YYYY-MM-DD').local().format('YYYY-MM-DD')
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     valid_until: moment.utc(e.target.value, 'YYYY-MM-DD').local().format('YYYY-MM-DD')
                                   })
                                 }}
                                 value={formData.valid_until}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}
                              />
                        <Calendar value={formData.valid_until}
                          locale="hu"
                          format={'yy-mm-dd'}
                          showIcon
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              valid_until: moment.utc(e.value).local().format('YYYY-MM-DD')
                            })
                            setNewFormData({
                              ...newFormData,
                              valid_until: moment.utc(e.value).local().format('YYYY-MM-DD')
                            })
                          }}/>
                        </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'price-list-item' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PricelistitemFormComponent);